export const languages = [
  'Allemand',
  'Anglais',
  'Arabe',
  'Arabe égyptien',
  'Bengali',
  'Bhodjpouri',
  'Cantonais',
  'Coréen',
  'Espagnol',
  'Français',
  'Gujarati',
  'Haoussa',
  'Hindi',
  'Indonésien',
  'Italien',
  'Japonais',
  'Javanais',
  'Kannada',
  'Mandarin',
  'Marathi',
  'Minnan',
  'Ourdou',
  'Pendjabi occidental',
  'Persan',
  'Philippin',
  'Portugais',
  'Russe',
  'Swahili',
  'Tamoul',
  'Télougou',
  'Thaï',
  'Turc',
  'Vietnamien',
  'Wu'
]